import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';
import { Base } from 'active-resource';

/**
 * Relationship classes
 */
export class JobApplicationsCsvFileAttributes {
  id: string;
  contents: string;
}

export class JobApplicationsCsvFileBelongsTo {}

export class JobApplicationsCsvFileHasOne {}

export class JobApplicationsCsvFileHasMany {}

/**
 * Utility interfaces
 */
export interface JobApplicationsCsvFileMethods {}

export interface JobApplicationsCsvFileInterface
  extends JobApplicationsCsvFileAttributes,
    JobApplicationsCsvFileBelongsTo,
    JobApplicationsCsvFileHasOne,
    JobApplicationsCsvFileHasMany,
    JobApplicationsCsvFileType {}

type JobApplicationsCsvFileType = GConstructor<JobApplicationsCsvFileInterface>;

export interface JobApplicationsCsvFileResource
  extends Base<JobApplicationsCsvFileAttributes>,
    JobApplicationsCsvFileInterface,
    JobApplicationsCsvFileMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<JobApplicationsCsvFileAttributes>({
    queryName: '/employer/job_applications/download',
    className: 'JobApplicationsCsvFile',
    AttributesClass: JobApplicationsCsvFileAttributes,
    BelongsToClasses: [
      {
        Klass: JobApplicationsCsvFileBelongsTo,
      },
    ],
    HasOneClasses: [
      {
        Klass: JobApplicationsCsvFileHasOne,
      },
    ],
    HasManyClasses: [
      {
        Klass: JobApplicationsCsvFileHasMany,
      },
    ],
  });

export const JobApplicationsCsvFileResourceClass = <TBase extends JobApplicationsCsvFileType>(
  BaseConstructor: TBase,
) => class extends BaseConstructor implements JobApplicationsCsvFileMethods {};

export class JobApplicationsCsvFileResource extends ClassExtender<JobApplicationsCsvFileInterface>(
  BaseClass,
  JobApplicationsCsvFileResourceClass,
) {}

/**
 * Resource instance
 */
export const JobApplicationsCsvFile = APILibrary.createResource<JobApplicationsCsvFileResource>(
  JobApplicationsCsvFileResource,
);
